<template>
  <div class="w-full  mx-auto flex items-center justify-center">
    <div ref="loading" class="pt-10">
      <Spinner></Spinner>
    </div>
  </div>
  <div ref="container"></div>
  <div ref="error"></div>
</template>

<script setup>
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { onMounted, useTemplateRef } from 'vue';
import Spinner from './Spinner.vue';

const props = defineProps({
  type: String
});

const spinner = useTemplateRef('loading');
const container = useTemplateRef('container');
const error = useTemplateRef('error');

const fetchClientSecret = async () => {
  // Fetch the AccountSession client secret
  let data = {};
  data[csrfTokenName] = csrfTokenValue;
  const response = await fetch('/actions/live-yoga-teachers/connect/get-account-session',
      {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      });
  if (!response.ok) {
    // Handle errors on the client side here
    const {error} = await response.json();
    console.error('An error occurred: ', error);
    error.value.removeAttribute('hidden');
    return undefined;
  } else {

    const {client_secret: clientSecret} = await response.json();

    // document.querySelector('#error').setAttribute('hidden', '');
    return clientSecret;
  }
}

const stripeConnectInstance = loadConnectAndInitialize({
  // This is your test publishable API key.
  // publishableKey: "pk_test_51Hf3whA9djpx0tsZwIc9BSTvenACfV7sAiZqinCvpSqZuliOJmO8tllMA3sFZeyHXT1kZFpGXLFS22A8CmxkKAsT00szimVi0m",
  publishableKey: "pk_live_51Hf3whA9djpx0tsZAM2JhnjimyGSwOg3SCoK9gVadmJPZahQpQU9a5vHUfGf8ZzzqaxxxZpanHyTIq17KyJvbocX00ll8Shoj0",
  fetchClientSecret: fetchClientSecret,
});


onMounted(() => {
  console.log('hello');
  console.log(container.value);
  if (props.type == 'payments') {
    const paymentComponent = stripeConnectInstance.create("payments");
    paymentComponent.setOnLoaderStart((event) => {
      console.log(spinner.value);
      spinner.value.classList.add('hidden');
    });
    container.value.appendChild(paymentComponent);
  }

  if (props.type == 'balance') {
    const payouts = stripeConnectInstance.create('balances');
    payouts.setOnLoaderStart((event) => {
      console.log(spinner.value);
      spinner.value.classList.add('hidden');
    });
    container.value.appendChild(payouts);
  }

  if (props.type == 'payouts') {
    const payouts = stripeConnectInstance.create('payouts');
    payouts.setOnLoaderStart((event) => {
      console.log(spinner.value);
      spinner.value.classList.add('hidden');
    });
    container.value.appendChild(payouts);
  }

  if (props.type == 'account') {
    const accountManagement = stripeConnectInstance.create('account-management');
    accountManagement.setOnLoaderStart((event) => {
      console.log(spinner.value);
      spinner.value.classList.add('hidden');
    });
    container.value.appendChild(accountManagement);
  }

  if (props.type == 'onboarding') {
    const accountOnboarding = stripeConnectInstance.create('account-onboarding');
    accountOnboarding.setOnExit(() => {
      console.log('User exited the onboarding flow');
    });
    accountOnboarding.setOnLoaderStart((event) => {
      console.log(spinner.value);
      spinner.value.classList.add('hidden');
    });
    container.value.appendChild(accountOnboarding);

// Optional: make sure to follow our policy instructions above
// accountOnboarding.setFullTermsOfServiceUrl('{{URL}}')
// accountOnboarding.setRecipientTermsOfServiceUrl('{{URL}}')
// accountOnboarding.setPrivacyPolicyUrl('{{URL}}')
// accountOnboarding.setSkipTermsOfServiceCollection(false)
// accountOnboarding.setCollectionOptions({
//   fields: 'eventually_due',
//   futureRequirements: 'include',
// })
// accountOnboarding.setOnStepChange((stepChange) => {
//   console.log(`User entered: ${stepChange.step}`);
// });
  }

});
</script>